export default __webpack_public_path__ + "static/media/logo_type.f25abc0b.svg";